module.exports = __webpack_public_path__ + "images/wechat/leave-request-faces-efe74c7e45e8cb0397bbfaafb3bb3bee.png";